import { ServicesURL } from "@utils/utilsApi";
import { DynamicFilterValue } from "@components/DynamicFilterCst/types";

export type CatalogEntityType = "activity" | "course" | "path";

export const CATALOG_URL_BY_TYPE: Record<CatalogEntityType, string> = {
  activity: ServicesURL.getActivities,
  course: ServicesURL.getCourses,
  path: ServicesURL.getPaths,
};

export const CATALOG_AGGREGATED_URL = ServicesURL.getAggregatedLO;

export const mapAggregatedType = (type?: string): CatalogEntityType => {
  const normalized = (type || "").toLowerCase();
  if (normalized === "course") return "course";
  if (normalized === "path") return "path";
  return "activity";
};

export type TabKey = "all" | "activities" | "courses" | "paths";

export type FieldValue = DynamicFilterValue;

export interface CatalogTabFilters {
  search?: string;
  fieldFilters?: Record<string, FieldValue>;
  sort?: string | null;
  page?: number;
}

export interface CatalogMeta {
  activeTab?: TabKey;
}

export interface SelectedLOItem {
  id: number;
  title: string;
  type: string;
  kind: "activity" | "course";
  entity: Record<string, any>;
  locked?: boolean;
}
